import React from 'react';
import Icon from '../../../components/AppIcon';

const ComingSoon = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-background to-muted/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-primary/10 via-accent/10 to-primary/10 rounded-2xl p-8 md:p-12 border border-primary/20 text-center">
          <Icon name="Sparkles" size={48} className="text-primary mx-auto mb-4" />
          <h3 className="text-2xl md:text-3xl font-heading font-bold text-foreground mb-4">
            Em Breve
          </h3>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto mb-6 leading-relaxed">
            Estamos trabalhando para trazer apartamentos residenciais que redefinem o conceito 
            de morar com sustentabilidade. Fique atento às novidades!
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-background/80 backdrop-blur-sm border border-border">
              <Icon name="Calendar" size={20} className="text-primary" />
              <span className="text-sm font-medium text-foreground">Lançamento em Breve</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-background/80 backdrop-blur-sm border border-border">
              <Icon name="Bell" size={20} className="text-primary" />
              <span className="text-sm font-medium text-foreground">Cadastre-se para Novidades</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComingSoon;
